
import { useState, useEffect, useCallback } from 'react';

// Simple interface for notification preferences
interface NotificationPreferences {
  enabled: boolean;
  volume: number;
}

// Default preferences
const defaultPreferences: NotificationPreferences = {
  enabled: false,  // Disabled by default (since we're removing sound)
  volume: 0,       // No volume (since we're removing sound)
};

export function useNotificationPreferences() {
  const [preferences, setPreferences] = useState<NotificationPreferences>(defaultPreferences);
  
  // Load preferences on mount
  useEffect(() => {
    try {
      const savedPrefs = localStorage.getItem('notification_preferences');
      if (savedPrefs) {
        setPreferences(JSON.parse(savedPrefs));
      }
    } catch (error) {
      console.error('Error loading notification preferences:', error);
    }
  }, []);

  // Check if notifications should be muted
  const shouldMute = useCallback(() => {
    // Always return true since we're removing sound
    return true;
  }, []);

  return {
    preferences,
    shouldMute,
  };
}
